import React from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Divider } from "@mui/material";
import { EditOutlined } from "@mui/icons-material";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { useGetSmsIntegrationDetailQuery } from "store/services/smsIntegrationApi";

import {
  SmsIntegrationDetailContext,
  useSmsIntegrationDetailContext,
} from "contexts/SmsIntegrationDetailContext";
import SmsIntegrationBasicDetail from "../SmsIntegration/SmsIntegrationComponents/SmsIntegrationBasicDetail";
import SmsIntegrationDetailTab from "../SmsIntegration/SmsIntegrationComponents/SmsIntegrationDetailTab";

const SmsIntegrationDetailScreen = () => {
  const { id } = useParams();

  const breadcrumbs = [
    { title: "SMS Integrations", path: "/app/crm/sms-integrations/list" },
    { title: "SMS Integration Detail" },
  ];

  // RTK Query
  const {
    data: smsIntegrationDetail,
    isLoading: loadingSmsIntegration,
    error,
  } = useGetSmsIntegrationDetailQuery(id);

  return (
    <SmsIntegrationDetailContext.Provider
      value={{ smsIntegrationDetail, loadingSmsIntegration }}
    >
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingSmsIntegration}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />

        <BreadcrumbLayout.Paper>
          <SmsIntegrationBasicDetail />
          <Divider />
          <SmsIntegrationDetailTab />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </SmsIntegrationDetailContext.Provider>
  );
};

export default SmsIntegrationDetailScreen;

const PageActions = () => {
  const { smsIntegrationDetail } = useSmsIntegrationDetailContext();
  return (
    <div className="flex items-center gap-4">
      <Link to={`/app/crm/sms-integrations/${smsIntegrationDetail?._id}/edit`}>
        <Button startIcon={<EditOutlined />} variant="contained">
          Edit
        </Button>
      </Link>
    </div>
  );
};